import React from 'react'
import {Row, Col} from 'react-bootstrap'

const DeliveryAddress = ({order}) => {
  let {attributes} = order;

  return (
    <div className="delivery-address">
      <Row>
        <Col lg={12}>
          <h4 className="title">Delivery address</h4>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <p>{attributes.outlet} {attributes['customer-number']}</p>
        </Col>
      </Row>
      <Row><Col lg={12}>{attributes['address-line-1']}</Col></Row>
      <Row><Col lg={12}>{attributes['address-line-2']}</Col></Row>
      <Row><Col lg={12}>{attributes['address-line-3']}</Col></Row>
      <Row><Col lg={12}>{attributes.town}</Col></Row>
      <Row><Col lg={12}>{attributes.county}</Col></Row>
      <Row><Col lg={12}>{attributes.eircode}</Col></Row>
    </div>
  )
};

export default DeliveryAddress


// WEBPACK FOOTER //
// ./src/components/my-orders/view/delivery-address.jsx